var map = {
	"./banner1.png": "ffe1",
	"./banner2.png": "ff18",
	"./banner3.png": "ce27",
	"./banner4.png": "3d7d",
	"./banner5.png": "4925",
	"./banner6.png": "752f",
	"./banner7.png": "f8a0",
	"./banner8.png": "fbf9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "047b";